(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('QuoteSplitSearch', QuoteSplitSearch);

    QuoteSplitSearch.$inject = ['$resource'];

    function QuoteSplitSearch($resource) {
        var resourceUrl =  'api/_search/quote-splits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
